import { render, staticRenderFns } from "./MySites.vue?vue&type=template&id=b7672062"
import script from "./MySites.vue?vue&type=script&lang=js"
export * from "./MySites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports